module.exports = __webpack_public_path__ + "img/home-screenshot3.d1942f8d.png";